import Axios from "./Axios";

// 🔍 Search API
export const fetchSearchResultsAPI = async (queryParam) => {
  try {
    const response = await Axios.get(`/search/?search=${queryParam}`);
    console.log("Search Results API:", response.data);
    return response.data;
  } catch (error) {
    console.log("Search API Error:", error?.response?.data || error);
    throw error;
  }
};

// 🟦 Categories API
export const getCategories = async () => {
  try {
    const response = await Axios.get("/menu/");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 📤 File Upload API
export const getImage = async ({ filename, image, userid, processes }) => {
  const payload = { filename, image, userid, processes };
  console.log("📦 Upload Payload:", payload);

  try {
    const response = await Axios.post("/fileuploadview/", payload);
    console.log("✅ Upload Success:", response.data);
    return response.data;
  } catch (error) {
    console.log("❌ Upload Failed:", error.response?.data || error);
    throw error;
  }
};

// 🛠 Warranty Details
export const warrantyDetails = async () => {
  try {
    const response = await Axios.get("/get_warrant_details/");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 🛠 Extend Warranty
export const warrantyExtend = async ({
   userid,
      orderno,
      serialnumber,
      invoiceimage,
      productimage,
      dealername,
      productid,
      category,
      modelno,
      startdate,
      scratchno,
      hologramno,
      enddate,
      warrantytype,
      warrantydays,
      warrantyid,
      pin,
      state,
      area,
      district,
      
}) => {
  const payload = {
   userid,
      orderno,
      serialnumber,
      invoiceimage,
      productimage,
      dealername,
      productid,
      category,
      modelno,
      startdate,
      scratchno,
      hologramno,
      enddate,
      warrantytype,
      warrantydays,
      warrantyid,
      pin,
      state,
      district,
      area,
  };

  console.log("📦 Warranty Payload:", payload);

  try {
    const response = await Axios.post("/warranty/", payload);
    console.log("Warranty Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("❌ Warranty API Error:", error.response?.data || error);
    throw error;
  }
};


export const warrantyClaim = async ({
   warrantyid ,
    date,
    userid ,
    clientid ,
    image ,
    discription,
   

}) => {
  const payload = {
   warrantyid ,
    date,
    userid ,
    clientid ,
    image ,
    discription,
   

  };

  console.log("📦 Warranty Payload:", payload);

  try {
    const response = await Axios.post("/warranty_claim/", payload);
    console.log("Warranty Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("❌ Warranty API Error:", error.response?.data || error);
    throw error;
  }
};
export const becameDealer = async ({ id, gst, firmname }) => {
  try {
    const response = await Axios.get(
      `/becomedealer/?id=${id}&gst=${gst}&firmname=${firmname}`
    );
    return response.data;
  } catch (error) {
    console.error("Become dealer error:", error);
    throw error;
  }
};



export const getVerificationLogs = async (userid) => {
  try {
    const response = await Axios.get("/verificationlog/", {
      params: { userid },
    });
    return response.data;
  } catch (error) {
    console.error("getVerificationLogs error:", error?.response?.data || error);
    throw error;
  }
};



export const getWarrantyList = async (userid) => {
  try {
    const response = await Axios.get("/warrentylist/", {
      params: { userid },
    });
    return response.data;
  } catch (error) {
    console.error("getWarrantyList error:", error?.response?.data || error);
    throw error;
  }
};

export const getVerificationList = async () => {
  try {
    const response = await Axios.get("/verificationlog/");
    return response.data;
  } catch (error) {
    console.error("getVerificationList error:", error?.response?.data || error);
    throw error;
  }
};

export const getDeliveryByPincode = async (pincode) => {
  try {
    console.log("Sending pincode:", pincode);

    const response = await Axios.get("/getpincodeservice/", {
      params: {
        filter_codes: pincode,
      },
    });

    console.log("Pincode API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("getDeliveryByPincode error:", error);
    throw error;
  }
};